(() => {
    // Dynamic calculation of mega menu column heights
    function equalizeToSmallest(parentItem, selector) {
        const mega = parentItem.querySelector('.mega-menu');
        if (!mega || mega.hasAttribute("data-height-applied")) return;
        const cols = mega.querySelectorAll(selector);
        const megaMenuMain = mega.querySelector(".mega-menu__main");
        if (cols.length < 2 || !megaMenuMain) return;
        const minHeight = Math.min(...Array.from(cols).map(c => c.offsetHeight));
        megaMenuMain.style.height = minHeight + "px";
        cols.forEach(col => col.style.height = minHeight + "px");
        mega.setAttribute("data-height-applied", "true");
    }

    function updateDrawerPosition() {
        if (window.innerWidth < 768) {
            const announcementBar = document.getElementById('shopify-section-announcement-bar');
            const header = document.getElementById('shopify-section-header');
            const announcementBarHeight = announcementBar?.offsetHeight || 0;
            const headerHeight = header?.offsetHeight || 0;
            const scrolledPastAnnouncementBar = window.scrollY >= announcementBarHeight;
            const totalHeight = scrolledPastAnnouncementBar ? headerHeight : announcementBarHeight + headerHeight;
            document.documentElement.style.setProperty('--dynamic-height', `${totalHeight}px`);
        } else {
            document.documentElement.style.setProperty('--dynamic-height', '0px');
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        updateDrawerPosition();
        // Correction Safari : recalcul après rendu complet
        setTimeout(updateDrawerPosition, 300);
    });
    window.addEventListener('resize', updateDrawerPosition);
    window.addEventListener('scroll', updateDrawerPosition);


    document.addEventListener('DOMContentLoaded', function () {
        // Submenu open logic
        document.querySelectorAll('.mega-menu').forEach(menu => {
            const rightCol = menu.querySelector('.mega-menu__right');
            const leftCol = menu.querySelector('.mega-menu__left');
            const itemsLeft = menu.querySelectorAll('.submenu-item');
            const defaultItem = menu.querySelector('.submenu-item.is-default');
            let defaultChildren = null;
            let defaultTitle = null;
            let activeItem = null;
            
            function setActiveItem(item) {
                leftCol.querySelector("a.active")?.classList.remove('active');
                item.querySelector("a").classList.add('active');
                activeItem = item;
            }
            itemsLeft.forEach(item => {
                const children = JSON.parse(item.dataset.children || '[]');
                const title = item.dataset.title || '';
                if (children.length > 0 && item === defaultItem) {
                    defaultChildren = children;
                    defaultTitle = title;
                    activeItem = item;
                }
                item.addEventListener('mouseenter', () => {
                    if (children.length > 0) {
                        setActiveItem(item);
                        renderChildren(rightCol, title, children);
                    }
                });
            });
            if (defaultChildren && activeItem) {
                renderChildren(rightCol, defaultTitle, defaultChildren);
                setActiveItem(activeItem);
            }
        });

        // Mobile menu drawer open/close logic
        const closeMobileNav = document.querySelector('.menu_mobile_toggle_x');
        if(closeMobileNav){
            closeMobileNav.addEventListener('click', ()=> {
                const mobileDrawer = document.querySelector('.mobile-navigation-drawer_custom');
                const mobileDrawerItems = document.querySelectorAll('.navigation__item.custom-navigation__item--with-children')
                if(mobileDrawer && mobileDrawer.classList.contains('mobile-navigation-drawer--child-open')){
                setTimeout(() => {
                    mobileDrawer.classList.remove('mobile-navigation-drawer--child-open')
                }, 400);
                }
                if(mobileDrawerItems.length){
                mobileDrawerItems.forEach((item) => {
                    if(item.classList.contains('navigation__item--open')){
                    setTimeout(() => {
                        item.classList.remove('navigation__item--open');
                    }, 400);
                    }
                });
                }
            });
        }

        // Mega menu open/close logic
        const OPEN_DELAY  = 120; 
        const CLOSE_DELAY = 180; 
        const items = document.querySelectorAll('.navigation__item');
        const overlay = document.querySelector('.mega-menu-overlay');

        items.forEach(item => {
            const trigger = item.querySelector('.navigation__link');
            const megaMenu = item.querySelector('.mega-menu');
            if (!trigger || !megaMenu) return;
            const rightCol = megaMenu.querySelector('.mega-menu__right');
            const leftCol = megaMenu.querySelector('.mega-menu__left');
            const itemsLeft = megaMenu.querySelectorAll('.submenu-item');

            theme.ProductBlockManager.loadImages(megaMenu);
            let timer = null;
            function setActiveItem(item) {
                leftCol.querySelector("a.active")?.classList.remove('active');
                item.querySelector("a").classList.add('active');
            }
            function openMenu() {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    overlay.classList.add('active');
                    megaMenu.classList.remove('closed');
                    item.classList.add('is-open');
                    equalizeToSmallest(item, '.mega-menu__main .mega-menu__main-sub');
                    trigger.setAttribute('aria-expanded', 'true');

                    // render first submenu with children
                    let defaultChildren = null;
                    let defaultTitle = null;
                    let activeItem = [...itemsLeft].find(item => {
                        const children = JSON.parse(item.dataset.children || '[]');
                        if (children.length > 0) {
                            defaultChildren = children;
                            defaultTitle = item.dataset.title || '';
                            return true;
                        }
                        return false;
                    });
                    if (defaultChildren && activeItem) {
                        renderChildren(rightCol, defaultTitle, defaultChildren);
                        setActiveItem(activeItem);
                    }
                }, OPEN_DELAY);
            }

            function closeMenu() {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    megaMenu.classList.add('closed');
                    item.classList.remove('is-open');
                    trigger.setAttribute('aria-expanded', 'false');
                    const stillOpen = document.querySelector('.navigation__item.is-open');
                    if (!stillOpen) {
                        overlay.classList.remove('active');
                    }
                }, CLOSE_DELAY);
            }

            item.addEventListener('mouseenter', openMenu);
            item.addEventListener('mouseleave', closeMenu);
            trigger.addEventListener('focus', openMenu);
            item.addEventListener('focusout', (e) => {
                if (!item.contains(e.relatedTarget)) closeMenu();
            });
        });
    });

    // render submenu
    function renderChildren(rightCol, title, children) {
        rightCol.innerHTML = '';

        if (title) {
            const div = document.createElement('div');
            div.textContent = title;
            div.classList.add("mega-menu_title")
            rightCol.appendChild(div);
        }

        if (children && children.length > 0) {
            const ul = document.createElement('ul');
            children.forEach(c => {
                const li = document.createElement('li');
                li.innerHTML = `<a href="${c.url}" class="mega-menu_navigation-link">${c.title}</a>`;
                ul.appendChild(li);
            });
            rightCol.appendChild(ul);
        }
    }
})();
